(function($) {
    $(function() {
        const urnwallModal = $('.js-urnwall-modal');
        const urnwallSlider = $('.js-urn-slider');

        $(document).on('click', '.js-close-urnwall-modal', function() {
            urnwallModal.addClass('visible-print');
            $('.about-box').removeClass('about-box-visible');
            $('.js-get-graveyard').addClass('information-tab-visible');
            window.widget.addSelection('select');
        });

        $.getUrnwallData = function getUrnwallData(id, colsToGet) {
            console.log('getUrnwallData');
            const urnwallModal = $('.js-urnwall-modal');
            const dataToSend = {
                graveId: id,
                xMin: 0,
                xMax: window.urnX || 100,
                yMin: 0,
                yMax: window.urnY || 100,
            };

            urnwallModal.removeClass('visible-print');

            $.ajax({
                url: `${window.api}/urns/`,
                type: 'GET',
                data: dataToSend,
                headers: {
                    Authorization: 'Bearer ' + window.iFrameToken,
                },
                async: false,
                success: function(response) {
                    createUrnwallSlider(response, colsToGet, urnwallSlider);
                },
            });
        };

        $.loadSelectedUrn = function loadSelectedUrn(urnId) {
            $.ajax({
                url: `${window.api}/urns/${urnId}`,
                type: 'GET',
                data: urnId,
                async: false,
                headers: {
                    Authorization: 'Bearer ' + window.iFrameToken,
                },
                success: function(response) {
                    const { deads, photos, description, fancyName } = response;
                    const column = response.xLabel + '.oszlop';
                    const row = response.yLabel + '.sor';
                    const position = row + '/' + column;

                    if (photos && photos.length !== 0) {
                        createThumbnailAndSlider(
                            photos,
                            $('.js-count-image'),
                            $('.js-modal-slider'),
                            $('.js-open-gallery')
                        );
                    } else {
                        $('.js-open-gallery').addClass('visible-print');
                    }

                    $('.js-load-one-urnwall-data')
                        .filter(`[data-id='${urnId}']`)
                        .addClass('urn--active');

                    deads.sort(function(a, b) {
                        var textA = a.name.toUpperCase();
                        var textB = b.name.toUpperCase();
                        return textA < textB ? -1 : textA > textB ? 1 : 0;
                    });

                    const output = createDeceasedList(deads, false);

                    $('.js-output-card').html(output.join(''));

                    if (description) {
                        const urnDescription = `
                            <div class="grave-description time">
                                <p>${description}</p>
                            </div>`;
                        const jsOutputCard = $('.js-output-card').html();
                        $('.js-output-card').html([urnDescription, jsOutputCard]);
                    }
                    $('.about-title').text(fancyName || position);
                    $('.about-box').addClass('about-box-visible');
                    if (deads.length === 0) {
                        $('#about-box-footer--button').addClass('visible-print');
                        $('#about-box-footer--cancel').addClass('visible-print');
                    } else {
                        resetSuggestionButtons();
                    }
                },
            });
        };

        // urnafal már meg van jelenítve és kiválasztunk egy urnát
        $(document).on('click', '.js-load-one-urnwall-data', function() {
            const urnId = $(this).data('id');
            const mobileView = window.innerWidth < 672;
            const tabletView = window.innerWidth >= 672 && window.innerWidth <= 1199;

            if (tabletView && !urnwallModal.hasClass('has-selected')) {
                urnwallModal.addClass('has-selected');

                $.getUrnwallData(window.graveId, 2);
                $.loadSelectedUrn(urnId);
                goToUrnwallActiveSlide(urnwallSlider);
                return;
            }

            if (mobileView) {
                $('.about-box').css({
                    height: '100%',
                    'z-index': '99',
                });
            }

            $('.js-load-one-urnwall-data').removeClass('urn--active');
            $('.js-load-one-urnwall-data')
                .filter(`[data-id='${urnId}']`)
                .addClass('urn--active');
            $.loadSelectedUrn(urnId);
        });

        $(window).on('resize orientationchange', function() {
            const tabletView = window.innerWidth >= 672 && window.innerWidth <= 1199;

            if ($('.js-urnwall-modal').hasClass('visible-print')) {
                return;
            }

            if (tabletView) {
                urnwallModal.addClass('has-selected');
                $.getUrnwallData(window.graveId, 2);
                urnwallSlider.slick('setPosition');
                return;
            }

            const colsToGet = getUrnwallCollsByWindowWidth();
            $.getUrnwallData(window.graveId, colsToGet);
            goToUrnwallActiveSlide(urnwallSlider);
        });
    });
})(jQuery);
